import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './Cart.css';

function Cart() {
  const { cartItems, removeFromCart, updateQuantity, getCartTotal } = useCart();
  const navigate = useNavigate();

  // Helper function to get image URL
  const getImageUrl = (image) => {
    if (!image) return '/placeholder.jpg';
    const url = typeof image === 'string' ? image : image.url;
    return url.startsWith('http') ? url : `${window.location.origin}/.netlify/functions/api${url}`;
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page container">
        <h1>Shopping Cart</h1>
        <div className="empty-cart">
          <p>Your cart is empty</p>
          <Link to="/products" className="continue-shopping-btn">Continue Shopping</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page container">
      <h1>Shopping Cart</h1>
      
      <div className="cart-content">
        <div className="cart-items">
          {cartItems.map(item => (
            <div key={`${item._id}-${item.selectedColor || 'default'}`} className="cart-item">
              <img src={getImageUrl(item.images && item.images[0])} alt={item.name} />
              
              <div className="item-details">
                <h3>{item.name}</h3>
                <p className="item-culture">{item.culturalOrigin || item.culture} | {item.category}</p>
                {item.selectedColor && (
                  <p className="item-color">Colour: {item.selectedColor}</p>
                )}
                {item.originalPrice ? (
                  <p className="item-price">
                    <span className="item-price--original">R{item.originalPrice.toFixed(2)}</span>
                    {' '}
                    <span className="item-price--sale">R{(item.price || 0).toFixed(2)}</span>
                    <span className="item-sale-tag">SALE</span>
                  </p>
                ) : (
                  <p className="item-price">R{(item.price || 0).toFixed(2)}</p>
                )}
              </div>

              <div className="item-quantity">
                <button onClick={() => updateQuantity(item._id, item.quantity - 1, item.selectedColor)}>-</button>
                <span>{item.quantity}</span>
                <button onClick={() => updateQuantity(item._id, item.quantity + 1, item.selectedColor)}>+</button>
              </div>

              <div className="item-total">
                <p>R{((item.price || 0) * item.quantity).toFixed(2)}</p>
              </div>

              <button onClick={() => removeFromCart(item._id, item.selectedColor)} className="remove-btn">
                Remove
              </button>
            </div>
          ))}
        </div>

        <div className="cart-summary">
          <h2>Order Summary</h2>
          <div className="summary-row">
            <span>Subtotal:</span>
            <span>R{(getCartTotal() || 0).toFixed(2)}</span>
          </div>
          <div className="summary-row">
            <span>Shipping:</span>
            <span>Calculated at checkout</span>
          </div>
          <div className="summary-row total">
            <span>Total:</span>
            <span>R{getCartTotal().toFixed(2)}</span>
          </div>
          
          <button onClick={() => navigate('/checkout')} className="checkout-btn">
            Proceed to Checkout
          </button>
          
          <Link to="/products" className="continue-link">Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
}

export default Cart;
